export default __webpack_public_path__ + "static/media/vnft.ace85b76.png";